export default __webpack_public_path__ + "static/media/menu-logo.e5b6ac5d.png";